module.exports = __webpack_public_path__ + "static/media/BusinessTask.b58c1af0.svg";